import swal from "sweetalert";

declare var jQuery:any;
declare var admin_var:any;
const postal_codes = require('./postal-codes.json');
export {};

type CountryKey = 'country_current' | 'shipping_country_current';

class MainClass {
    private post_code_placeholder:string;
    private country_current:string;
    private shipping_country_current: string;

    constructor() {
        jQuery('#lms-show-button').on('click', (e:any) => {
            jQuery('.lms-side-bar').addClass('show');
        })
        jQuery('.lms-close-side-bar').on('click', (e:any) => {
            jQuery('.lms-side-bar').removeClass('show');
        })
        let simpleProduct:any = jQuery('.product.type-product.product-type-simple');
        if (simpleProduct.length > 0) {
            simpleProduct.append('<div class="lms-loader"><div class="lms-loader-spinner"></div></div>');
        }

        this.post_code_placeholder = jQuery('#billing_postcode').attr('placeholder');

        const setupHandlers = (fieldId: string, countryKey: CountryKey, postcodeFieldId: string, errorFieldId: string) => {
            const countrySelect: any = jQuery(`#${fieldId}_country`);
            const postcodeField = jQuery(`#${fieldId}_postcode`);
            const errorField = jQuery(`#${errorFieldId}`);

            if (countrySelect.length > 0) {
                this[countryKey] = postal_codes.hasOwnProperty(countrySelect.find('option:selected').val())
                    ? countrySelect.find('option:selected').val()
                    : 'CA';
                this.updatePostalCodePlaceholder(this[countryKey], postcodeFieldId);
    
                countrySelect.on('change', (e: any) => {
                    const selectedValue = jQuery(e.target).find('option:selected').val();
                    if (postal_codes.hasOwnProperty(selectedValue)) {
                        this[countryKey] = selectedValue;
                    }
                    postcodeField.val('');
                    this.updatePostalCodePlaceholder(this[countryKey], postcodeFieldId);
                });
    
                postcodeField.on('keyup', (e: any) => {
                    jQuery(e.target).val(jQuery(e.target).val().toUpperCase());
                }).on('keypress', (e: any) => {
                    if (postal_codes.hasOwnProperty(this[countryKey]) && postal_codes[this[countryKey]].placeholder) {
                        const charCode = e.which || e.keyCode;
                        const placeholder = postcodeField.attr('placeholder');
                        const currValue = postcodeField.val().replace(/[^0-9A-Za-z]/g, "");
    
                        const isInvalidChar = isNaN(parseInt(placeholder.replace(/[^0-9A-Z]/g, "")))
                            ? String.fromCharCode(charCode).match(/[^0-9A-Za-z.]/g)
                            : String.fromCharCode(charCode).match(/[^0-9.]/g);
    
                        if (isInvalidChar || (placeholder.replace(/[^0-9A-Z]/g, "").length <= currValue.length && e.target.selectionStart === e.target.selectionEnd)) {
                            return false;
                        }
    
                        this.updatePostalCode(postcodeField, currValue, placeholder);
                    }
                }).on('blur', (e: any) => {
                    if (postal_codes.hasOwnProperty(this[countryKey])) {
                        if (postcodeField.val().match(postal_codes[this[countryKey]].regex)) {
                            errorField.removeClass('woocommerce-invalid woocommerce-invalid-required-field').addClass('woocommerce-validated');
                            jQuery(`#${fieldId}_postcode-error`).remove();
                        } else {
                            errorField.addClass('woocommerce-invalid woocommerce-invalid-required-field').removeClass('woocommerce-validated');
                            jQuery(`#${fieldId}_postcode-error`).remove();
                            postcodeField.after(`
                                <span id="${fieldId}_postcode-error" class="help-inline">Invalid postal code</span>
                            `);
                        }
                    }
                });
            }
        };

        this.country_current = 'CA';
        setupHandlers('billing', 'country_current', 'billing_postcode', 'billing_postcode_field');

        this.shipping_country_current = 'CA';
        setupHandlers('shipping', 'shipping_country_current', 'shipping_postcode', 'shipping_postcode_field');
    }

    public updatePostalCodePlaceholder(country: string, field: string = 'billing_postcode') {
        const targetField = field === 'billing_postcode' ? '#billing_postcode' : '#shipping_postcode';
        const placeholder = postal_codes.hasOwnProperty(country) && postal_codes[country].placeholder
            ? postal_codes[country].placeholder
            : this.post_code_placeholder;
        jQuery(targetField).attr('placeholder', placeholder);
    }

    public updatePostalCode(elem:any, currValue:string, placeholder:string) {
        if ( postal_codes.hasOwnProperty(this.country_current) ) {
            let i:number = 0;
            let j:number = 0
            let newValstring:string = "";
            for (i = 0; i < placeholder.length; i++) {
                if (j >= currValue.length) {
                    break;
                }
                if (String(placeholder.charAt(i)).match(/[^0-9A-Za-z.]/g)) {
                    newValstring += placeholder.charAt(i);
                } else {
                    newValstring += currValue.charAt(j);
                    j++;
                }
            }
            elem.val(newValstring);
        }
    }

    public startEvents() {
        let countdown:any = jQuery('.event-countdown-area');
        
        if (countdown.length > 0) {
            let event_utc_date:string = countdown.data('utcEventDate');
            let event_date:string = countdown.data('eventDate');
            let event_timezone:string = countdown.data('eventTimezone');

            if( event_date == '-' && !event_utc_date) {
                countdown.hide();
                return;
            } // exit if date is empty

            let countDownDate:any = '';

            if( event_utc_date ) {
                countDownDate = new Date(event_utc_date);
            } else {
                countDownDate = this.convertTZ(event_date, event_timezone).getTime();
            }

            let x:any = setInterval(()=>  {
                // Get today's date and time
                let now:number = new Date().getTime();

                // Find the distance between now and the count down date
                let distance:number = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                let days:number = Math.floor(distance / (1000 * 60 * 60 * 24));
                let hours:number = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                let minutes:number = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                let seconds:number = Math.floor((distance % (1000 * 60)) / 1000);

                // Output the result in an element with id="demo"
                jQuery(".event-countdown-area").text(days + "d " + hours + "h "
                    + minutes + "m " + seconds + "s ");

                // If the count down is over, write some text
                if (distance < 0) {
                    clearInterval(x);
                    jQuery(".event-countdown-area").text("0d 0h 0m 0s");
                    jQuery(countdown).hide();

                    let room_id:any = jQuery('#vmm_join_room_id').first().val();
                    let chek_action:string = jQuery('#check_room_action').first().val();
                    jQuery.ajax({
                        url: admin_var.ajax_url,
                        type: 'POST',
                        data: {
                            action: chek_action, 
                            post_id: room_id
                        },
                        success: (res:any) => {
                            if ( ! res.data.resource ) {
                                jQuery('.button.product_type_simple.product_page').attr('disabled', 'disabled');
                            } else {
                                jQuery('.button.product_type_simple.product_page').removeAttr('disabled');
                            }
                        }
                    });
                } else {
                    jQuery(countdown).show();
                }
            }, 1000);
        }
        this.loadCheckoutEvents();
        jQuery( document ).on( 'heartbeat-send', ( event:any, data:any ) => {
            let vm_room_id:any = jQuery('#vmm_join_room_id')
            // Add additional data to Heartbeat data.
            if (vm_room_id.length > 0){
                if (jQuery('ul.products').length > 0) {
                    data.user_active_courses = true;
                } else {
                    data.course_active = vm_room_id.val();
                }
            }
        });
        jQuery( document ).on( 'heartbeat-tick', ( event:any, data:any ) => {
            // Check for our data, and use it.
            if (data.hasOwnProperty('course_active')) {
                if ( ! data.course_active ) {
                    jQuery('.button.product_type_simple.product_page').attr('disabled', 'disabled');
                } else {
                    jQuery('.button.product_type_simple.product_page').removeAttr('disabled');
                }
            }
            if (data.hasOwnProperty('products')) {
                jQuery('.button.product_type_simple').each((_:any, elem:any) => {
                    let jElem:any = jQuery(elem);
                    let roomInput:any = jElem.parent().find('#vmm_join_room_id');
                    if (roomInput.length > 0) {
                        if (data.products.includes(parseInt(roomInput.val()))) {
                            jElem.removeAttr('disabled');
                        } else {
                            jElem.attr('disabled', 'disabled');
                        }
                    }
                });
            }
        });

        jQuery('.lms-multiple-value').on('click', (e:any) => {
            if (!e.target.value) {
                return;
            }
            let inputName:string = e.target.name.replace('multiple_checkbox_', '');
            let inputElem = jQuery('input[name="'+inputName+'"]');
            console.log('----->', inputName);
            console.log('----->', inputElem);
            if (inputElem.length > 0) {
                let multipleChoiceVal:any = JSON.parse(inputElem.val());
                console.log('----->', e.target.checked);
                if (e.target.checked) {
                    multipleChoiceVal.push(e.target.value);
                } else {
                    let index:number = multipleChoiceVal.indexOf(e.target.value);
                    if (index > -1) {
                        multipleChoiceVal.splice(index, 1);
                    }
                }
                inputElem.val(JSON.stringify(multipleChoiceVal));
                console.log('----->', multipleChoiceVal);
            }
        });

        jQuery('.button.enroll_now').on('click', (e:any) => {
            e.preventDefault();
            let buttonElem:any = jQuery(e.target);
            let prod_id:any = buttonElem.data('enrollUser');
            jQuery('.lms-loader').show();
            let login:any = jQuery.post( admin_var.ajax_url, {action: "enroll_free_course", prod_id: prod_id, nonce: admin_var.nonce} )
                .done(( data:any ) => {
                    jQuery('.lms-loader').hide();
                    if (data.success) {
                        let priceLabel: any = buttonElem.closest('.vm_tile_background').find('.vmh_accent_text.price_wrapper label');
                        buttonElem.remove();
                        if (priceLabel.length > 0) {
                            priceLabel.text('(PURCHASED)');
                            priceLabel.css('font-size', '12px');
                        }
                    } else {
                        alert('Not enrolled');
                    }
                }).fail(function(xhr:any, status:any, error:any) {
                    jQuery('.lms-loader').hide();
                    alert('Not enrolled');
                });
        });

        console.log('=====> HERE I GO AGAIN!!!', jQuery('#course_start_date').length);
        if ( jQuery('#course_start_date').length > 0 ) {
            let timestamp = jQuery('#course_start_date').val();
            let date = new Date(timestamp * 1000);
            jQuery('.row-value.start-date').text(date.toLocaleDateString("en-US", {
                weekday: 'long', year: 'numeric', month: 'long',
                day: 'numeric', hour: 'numeric', minute: 'numeric'
            }));
            jQuery('.row-value.timezone').text(Intl.DateTimeFormat().resolvedOptions().timeZone);
        }
    }

    private loadCheckoutEvents() {
        jQuery('.lms-checkout-wrap.form-row input.lms-checkout-input').on('change keydown', (e:any) => {
            let element:any = jQuery(e.target);
            let value:string = element.val();
            console.log()
            if (!value) {
                if (e.keyCode == 8 || e.keyCode == 46) {
                    element.closest('.lms-checkout-wrap').removeClass('lms-is-active');
                } else {
                    element.closest('.lms-checkout-wrap').addClass('lms-is-active');
                }
            } else if (value.length == 1) {
                if (e.keyCode == 8 || e.keyCode == 46) {
                    element.closest('.lms-checkout-wrap').removeClass('lms-is-active');
                } else {
                    element.closest('.lms-checkout-wrap').addClass('lms-is-active');
                }
            }

        })
        jQuery('.woocommerce-checkout .dashicons-arrow-left-alt2.lms-accordion-handle').on('click', (e:any) => {
            e.preventDefault();
            let handle:any = jQuery(e.target);
            let content:string = handle.data('content');
            if (handle.hasClass('open')) {
                handle.removeClass('open');
                jQuery('.' + content).slideToggle('slow');
            } else {
                handle.addClass('open');
                jQuery('.' + content).slideToggle('slow');
            }
        });

        jQuery('#copy-acc-info').on('click', (e:any) => {
            e.preventDefault();
            jQuery('#billing_first_name').val(jQuery('#lms_account_first_name').val());
            jQuery('#billing_last_name').val(jQuery('#lms_account_last_name').val());
            jQuery('#billing_email').val(jQuery('#lms_account_email').val());
            if (jQuery('#lms_account_country').length != 0) {
                jQuery('#billing_country').val(jQuery('#lms_account_country').val());
            } else if (jQuery('#lms_billing_country').length != 0) {
                jQuery('#billing_country').val(jQuery('#lms_billing_country').val());
            }
            if (jQuery('#lms_account_city').length != 0) {
                jQuery('#billing_city').val(jQuery('#lms_account_city').val());
            } else if (jQuery('#lms_billing_city').length != 0) {
                jQuery('#billing_city').val(jQuery('#lms_billing_city').val());
            }
            if (jQuery('#lms_account_address_1').length != 0) {
                jQuery('#billing_address_1').val(jQuery('#lms_account_address_1').val());
            } else if (jQuery('#lms_billing_address_1').length != 0) {
                jQuery('#billing_address_1').val(jQuery('#lms_billing_address_1').val());
            }
            if (jQuery('#lms_account_address_2').length != 0) {
                jQuery('#billing_address_2').val(jQuery('#lms_account_address_2').val());
            } else if (jQuery('#lms_billing_address_2').length != 0) {
                jQuery('#billing_address_2').val(jQuery('#lms_billing_address_2').val());
            }
            if (jQuery('#lms_account_state').length != 0) {
                jQuery('#billing_state').val(jQuery('#lms_account_state').val());
            } else if (jQuery('#lms_billing_state').length != 0) {
                jQuery('#billing_state').val(jQuery('#lms_billing_state').val());
            }
            if (jQuery('#lms_account_postcode').length != 0) {
                jQuery('#billing_postcode').val(jQuery('#lms_account_postcode').val());
            } else if (jQuery('#lms_billing_postcode').length != 0) {
                jQuery('#billing_postcode').val(jQuery('#lms_billing_postcode').val());
            }
            if (jQuery('#lms_account_phone').length != 0) {
                jQuery('#billing_phone').val(jQuery('#lms_account_phone').val());
            } else if (jQuery('#lms_billing_phone').length != 0) {
                jQuery('#billing_phone').val(jQuery('#lms_billing_phone').val());
            }
        });

    }

    private convertTZ(date:any, tzString:string) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
    }
}

// Add an event listener for 'woof_init_search_form'
document.addEventListener('woof_init_search_form', function (event:any) {
    console.log('WOOF search form initialized:', event.detail);
    // Place your custom logic here

    jQuery('.WOOF_Widget .widget-woof > div').addClass('hide_blur')
});

jQuery( document ).ready(function($:any) {
    let mainClass:MainClass = new MainClass();
    mainClass.startEvents();

    let menuStick = $(".lms-stick-menu");
    if (menuStick.length == 1) {
        let stickyOffset = menuStick[0].offsetTop
        // When the user scrolls the page, execute myFunction
        window.onscroll = () => {
            if (window.pageYOffset >= stickyOffset) {
                $(".lms-stick-menu").addClass("sticky");
            } else {
                $(".lms-stick-menu").removeClass("sticky");
            }
        };
    }



   
});
    